import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useCurrentClientAtom } from 'atoms/clientAtom';

import { APP_ROUTES } from '../constants';

// COMPONENTS
import NavTabs from './NavTabs';
import CustomerDataError from './CustomerDataError';

const TAB_OPTIONS = [
  { label: 'Overview', value: APP_ROUTES.AUTO_OPTIMIZE_OVERVIEW },
  { label: 'Reports', value: APP_ROUTES.AUTO_OPTIMIZE_REPORTS },
];

function AutoOptimize() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [{ current_client_data_available, current_client_data_status }] =
    useCurrentClientAtom();

  useEffect(() => {
    if (pathname === APP_ROUTES.AUTO_OPTIMIZE) {
      navigate(APP_ROUTES.AUTO_OPTIMIZE_OVERVIEW);
    }
  }, [pathname, navigate]);

  // OSM-1983 — When the current account has no valid BQ dataset, bail
  // out to the shared empty state instead of rendering the module shell,
  // so users are not stuck on a broken page. Sidebar stays mounted.
  if (current_client_data_available === false) {
    return <CustomerDataError status={current_client_data_status} />;
  }

  return (
    <NavTabs options={TAB_OPTIONS}>
      <Outlet />
    </NavTabs>
  );
}

export default AutoOptimize;
